import Overlay from './Overlay';
export default Overlay;
//# sourceMappingURL=index.js.map